export enum EscalationType {
  Payment = 'payment',
  Organization = 'organization'
}
